export default __webpack_public_path__ + "static/default-ccfbe4e5b98ecda6bfcb0254043781cd.png";